export default __webpack_public_path__ + "static/media/africam-safari-logo.52d25f32.png";